import { FC } from 'react';

import { useTheme } from 'styled-components';

import { ArrowZone, Overlay } from './styles';
import { Icon } from '../Icons';

interface ScrollOverlayProps {
  ulRef: React.RefObject<HTMLUListElement>;
}

export const ScrollOverlay: FC<ScrollOverlayProps> = ({ ulRef }) => {
  const theme = useTheme();
  const handleScroll = (direction: 'left' | 'right'): void => {
    if (ulRef.current) {
      ulRef.current.scrollBy({
        left: direction === 'left' ? -140 : 140,
        behavior: 'smooth',
      });
    }
  };

  return (
    <Overlay>
      <ArrowZone
        onClick={() => handleScroll('left')}
        style={{
          right: '32px',
        }}
      >
        <Icon type="skip-left-fill" color={theme.neutral[0]} size={30} />
      </ArrowZone>
      <ArrowZone
        onClick={() => handleScroll('right')}
        style={{
          left: '32px',
        }}
      >
        <Icon type="skip-right-fill" color={theme.neutral[0]} size={30} />
      </ArrowZone>
    </Overlay>
  );
};
